import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 15l3 -3l-3 -3","key":"svg-0"}],["path",{"d":"M3 15l3 -3l-3 -3","key":"svg-1"}],["path",{"d":"M6 12l15 0","key":"svg-2"}]]

const IconArrowRightTail = createReactComponent('outline', 'arrow-right-tail', 'ArrowRightTail', __iconNode);

export default IconArrowRightTail;